interface IGetLeadsExportModalTitleProps {
    isAllSelected: boolean;
    rowsTotalCount: number;
    rowsToBeExported: unknown[];
    dataGroup: string | undefined;
}

export const getLeadsExportModalTitle = ({
    isAllSelected,
    rowsTotalCount,
    rowsToBeExported,
    dataGroup,
}: IGetLeadsExportModalTitleProps) =>
    `Export ${isAllSelected ? rowsTotalCount : rowsToBeExported.length} ${
        dataGroup ?? ''
    }`;
